import React, { useState, useEffect } from "react";
import { Button,Box,Text } from "@chakra-ui/react";
import {
  paymentCreateOrderId,
  paymentVerifyOrder,
  getPaymentDetails,
  fetchUserData,
  storePaymentRecord,
} from "../../allApi/api";
import { UserAuth } from "../../Supabase/context/AuthContext";
import PricingCard from "./PricingCard";
import PaymentSuccess from "./PaymentSuccess ";

function Payment() {
  const { session } = UserAuth();
  const user = session?.user;

  const [userInfo, setUserInfo] = useState({});
  const [paymentStatus, setPaymentStatus] = useState("");
  const [error, setError] = useState(null);
  const [paymentId,setPaymentId] = useState("");

  useEffect(() => {
    const initUserInfo = async () => {
      const baseInfo = user?.user_metadata || {};
      const supabaseUser = {
        name:
          baseInfo.display_name ||
          baseInfo.name ||
          baseInfo.full_name ||
          baseInfo.username ||
          "User",
        email: user.email || "",
      };

      try {
        const fetchedData = await fetchUserData();
        setUserInfo({
          ...supabaseUser,
          ...fetchedData,
          email: supabaseUser.email,
        });
      } catch {
        setUserInfo(supabaseUser);
      }
    };

    if (user) initUserInfo();
  }, [user]);

  const handleCreateOrder = async (planType) => {
    try {
      setError(null);

      const createOrder = await paymentCreateOrderId({
        membershipPlan: planType,
        email: userInfo?.email,
      });

      const { amount, currency, id: order_id } = createOrder?.order;
      const options = {
        key: createOrder?.Api_Key_Id,
        amount,
        currency,
        name: "Waveflow-Studio",
        description: `${planType} Plan Subscription`,
        order_id,
        handler: async (response) => {
          await handleSuccessfulPayment(response,planType);
        },
        prefill: {
          name: userInfo?.name,
          email: userInfo?.email,
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "blue",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        setError("Payment Failed: " + response.error.description);
      });
      rzp.on("payment.cancel", function () {
        setError("Payment Cancelled");
      });
      rzp.open();
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  const handleSuccessfulPayment = async (response, planType) => {
    try {
      const verifyRes = await paymentVerifyOrder({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature,
      });

      if (verifyRes?.data?.verified) {
        const detailsRes = await getPaymentDetails({
          razorpay_payment_id: response.razorpay_payment_id,
        });

        const status = detailsRes?.data?.status;
        setPaymentId(response.razorpay_payment_id);
        if (status === "captured" || status === "authorized") {
          await storePaymentRecord({
            name: userInfo?.name,
            email: userInfo?.email,
            plan: planType,
            razorpay_payment_id: response.razorpay_payment_id,
          });
          setPaymentStatus("success");
        } else {
          setError("Payment was not successful. Try again.");
        }
      } else {
        setError("Payment verification failed.");
      }
    } catch {
      setError("Something went wrong during payment verification.");
    }
  };

  if (paymentStatus === "success") {
    return (
      <div>
        <PaymentSuccess email={userInfo?.email} name={userInfo?.name || "User"} orderId={paymentId}/>
      </div>
    );
  }

  return (
    <div>
      {/* <Button onClick={()=>handleCreateOrder("Silver")}>Silver</Button>
      <Button onClick={()=>handleCreateOrder("Gold")}>Gold</Button> */}
      <Box textAlign={"center"} fontWeight={500} mt={"30px"} mb={"10px"} >
        <Text fontSize="2xl" >
          Find Your Perfect Plan
        </Text>
        <Text color={"#797878"} fontSize="sm" >
          Discover the ideal plan to fuel your business growth. Our <br/> pricing options are carefully crafted to cater to businesses.
        </Text>
      </Box>
      <PricingCard handleCreateOrder={handleCreateOrder} />
    </div>
  );
}

export default Payment;
